import React, { useEffect, useState } from 'react';
import Select from "react-select"
import AsyncSelect from 'react-select/async';
import { Button, Modal, Spinner, Table } from "react-bootstrap";
import { getContacts, mergeContacts } from "requesters/contactRequester"
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { getBaseUrl } from '../../reducers';
import { toast } from 'react-toastify';
import SweetAlert from 'react-bootstrap-sweetalert';
import SpinnerText from './SpinnerText';

const ContactDuplicate = ({selectedContacts = [], setShowMergeInfo}) => {
    const baseUrl = useSelector(getBaseUrl);
    const [defaultContact, setDefaultContact] = useState({});
    const [duplicateContacts, setDuplicateContacts] = useState([]);
    const [searchedContact, setSearchedContact] = useState([]);
    const { clientTypes } = useSelector(state => state.options);
    const [merging, setMerging] = useState(false);
    const [showConfirmButton, setShowConfirmButton] = useState(false);
    const clientTypeOptions = clientTypes.map(v => ({ value: v[1], label: v[0] }))
    useEffect(() => {
        const contacts_details = selectedContacts.sort((a,b) => parseInt(a.attributes.id,10) - parseInt(b.attributes.id,10))
        // console.log(contacts_details)
        setDuplicateContacts(contacts_details);
        setDefaultContact(contacts_details?.[0]?.attributes ?? {})
    }, [selectedContacts]);
     
    const inputChange = (e, name) => {
        console.log(e.target.value, name)
        setDefaultContact({...defaultContact, [name]: e.target.value})
    }
    const changeDefaultContact = (id) => {
        const new_default = duplicateContacts.find(x => x.attributes.id === id)
        setDefaultContact(new_default?.attributes ?? {})
    }
    const loadContacts = async (inputVal) => {
        let options = []
        if(inputVal.trim().length >= 4) {
            const request = await getContacts(baseUrl, {
              by_keyword: inputVal,
            })
            const data = Object.values(_.get(request.response, "contact", {}));
            options = data.map(d => ({label: d.attributes.fullName, value: d.attributes.id, data: d}))
        }
        return options;
    }
    const handleAddContactToDuplicate = () => {
        const newContact = searchedContact.map(d => d.data);
        setSearchedContact([])
        setDuplicateContacts([...duplicateContacts, ...newContact])
    }
    const handleDeleteDuplicateContact = (id) => {
        const newDuplicates = duplicateContacts.filter(x => x.id !== id);
        setDuplicateContacts(newDuplicates)
    }
    const contactFilterOption = (candidata, input) => {
        return !duplicateContacts?.map(dup => parseInt(dup.id, 10))?.includes(candidata.value);
    }
    const handleCellContentClick = (name, value) => {
        if(name === "name") {
            setDefaultContact({...defaultContact, firstName: value.firstName, lastName: value.lastName, fullName: value.fullName});
            return;
        }
        setDefaultContact({...defaultContact, [name]: value});
    }
    const validateForm = () => {
        const {email, firstName, lastName} = defaultContact;
        const fields = [{email, firstName, lastName}];
        if(!defaultContact.email || !defaultContact.firstName || !defaultContact.lastName) {
            toast.success(
                <div>
                    <span role="img" aria-label="failure-icon">❌</span>
                    <span className="ml-2">Please check the form for required fields.</span>
                </div>,
                {
                    toastId: "rails-flash",
                    containerId: "main"
                }
            )
            return false;
        }
        return true;
    }
    const handleMergeContact = async () => {
        if(!validateForm()) return;
        setMerging(true);
        const contact = {last_name: defaultContact.lastName, first_name: defaultContact.firstName, email: defaultContact.email, phone_number: defaultContact.phoneNumber, company: defaultContact.company, client_type: defaultContact.clientTypeRaw};
        const request = await mergeContacts(
            baseUrl,
            defaultContact.id,
            {
                data: {contact},
                contact_merge_ids: duplicateContacts.filter(x => x.attributes.id !== defaultContact.id).map(c => c.attributes.id)
            }
        );
        if(request.status === 200) {
            toast.success(
                <div>
                    <span role="img" aria-label="success-icon">✅</span>
                    <span className="ml-2">Contacts merged successfully.</span>
                </div>,
                {
                    toastId: "rails-flash",
                    containerId: "main"
                }
            )
            setShowMergeInfo(false);
            window.location.reload();
            return;
        }
        setMerging(false);
    }
    return <Modal show={duplicateContacts.length > 0 } backdrop="static" size='xl' >
        <Modal.Body className='p-0'>
            <Table striped bordered className='w-100 text-md'>
                <thead>
                    <tr>
                        <th width="30px"></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Company</th>
                        <th>Phone</th>
                        <th width={200}>Client Type</th>
                        <th width={100}>Related Jobs</th>
                        <th width={30}></th>
                    </tr>
                </thead>
                <tbody>
                    {duplicateContacts?.map((contact) => (<tr key={`duplicate-contact-${contact.attributes.id}`}>
                        <td><input type="checkbox" checked={defaultContact?.id === contact.attributes.id} onChange={() => changeDefaultContact(contact.attributes.id)} /></td>
                        <td onClick={(e) => handleCellContentClick('name', contact.attributes)}>{contact.attributes.fullName}</td>
                        <td onClick={(e) => handleCellContentClick('email', contact.attributes.email)}>{contact.attributes.email}</td>
                        <td onClick={(e) => handleCellContentClick('company', contact.attributes.company)}>{contact.attributes.company}</td>
                        <td onClick={(e) => handleCellContentClick('phoneNumber', contact.attributes.phoneNumber)}>{contact.attributes.phoneNumber}</td>
                        <td onClick={(e) => handleCellContentClick('clientTypeRaw', contact.attributes.clientTypeRaw)}>{contact.attributes.clientType}</td>
                        <td align='right'>{contact.attributes.jobServicesCount}</td>
                        <td align='right'>
                            {defaultContact?.id !== contact.attributes.id && <i
                                className="bi bi-x-circle-fill text-danger"
                                title="Remove Contact"
                                onClick={() => handleDeleteDuplicateContact(contact.attributes.id)}
                            />}
                        </td>
                    </tr>))}
                    <tr><td colSpan={8}></td></tr>
                    <tr>
                        <td colSpan={8}>
                            <div className="d-flex justify-content-end">
                                <AsyncSelect cacheOptions defaultOptions loadOptions={loadContacts} size="sm" styles={{control: (styles) => ({...styles, width: 400})}} value={searchedContact} isMulti onChange={(E) => setSearchedContact(E)} filterOption={contactFilterOption} />
                                <Button size="sm" onClick={handleAddContactToDuplicate}>Add Contact to Merge</Button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </Table>
            <div className='w-50 p-2'>
                <div className="form-group row">
                    <label className="col-3 col-form-label">Email*</label>
                    <div className="col-9">
                    <input
                        name="email"
                        className="form-control"
                        type="text"
                        placeholder="Email"
                        value={defaultContact?.email || ""}
                        onChange={e => inputChange(e, 'email')} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">First Name*</label>
                    <div className="col-9">
                    <input
                        name="first_name"
                        className="form-control"
                        type="text"
                        placeholder="First Name"
                        value={defaultContact?.firstName}
                        onChange={e => inputChange(e, 'firstName')} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">Last Name*</label>
                    <div className="col-9">
                    <input
                        name="last_name"
                        className="form-control"
                        type="text"
                        placeholder="Last Name"
                        value={defaultContact?.lastName}
                        onChange={e => inputChange(e, 'lastName')} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">Phone Number</label>
                    <div className="col-9">
                    <input
                        name="phone_number"
                        className="form-control"
                        type="text"
                        placeholder="optional"
                        value={defaultContact?.phoneNumber}
                        onChange={e => inputChange(e, 'phoneNumber')} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">Company</label>
                    <div className="col-9">
                    <input
                        name="company"
                        className="form-control"
                        type="text"
                        placeholder="optional"
                        value={defaultContact?.company}
                        onChange={e => inputChange(e, 'company')} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">Client Type</label>
                    <div className="col-9">
                    <Select
                        name="client_type"
                        placeholder="Select"
                        value={_.filter(clientTypeOptions, ["value", defaultContact?.clientTypeRaw])}
                        options={clientTypeOptions}
                        onChange={e => setDefaultContact({...defaultContact, clientTypeRaw: _.get(e, "value", "")})} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">Related Jobs</label>
                    <div className="col-9">
                        {_.sum(duplicateContacts.map(c => c.attributes.jobServicesCount))}
                    </div>
                </div>
            </div>
            <SweetAlert
                confirmBtnText={merging ? <SpinnerText text="Merging..." /> : 'Continue'}
                confirmBtnCssClass={`btn btn-red ${merging ? 'disabled' : ''}`}
                cancelBtnText="Cancel"
                showCancel
                showConfirm
                show={showConfirmButton}
                title="Are you sure to merge these contacts?"
                onConfirm={handleMergeContact}
                onCancel={() => setShowConfirmButton(false)}
            >
                There are {_.sum(duplicateContacts.filter(x => x.attributes.id !== defaultContact.id).map(c => c.attributes.jobServicesCount))} related jobs to be merge.
                This action cannot be undone.
            </SweetAlert>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outlined-blue" onClick={() => setShowMergeInfo(false) }>Cancel</Button>
            <Button variant="outlined-red" onClick={() => setShowConfirmButton(true)} disabled={duplicateContacts.length <= 1 || merging}>
                Merge
            </Button>
        </Modal.Footer>
    </Modal>
}
export default ContactDuplicate;